import { createFileRoute } from "@tanstack/react-router";

import { CountFormPage } from "../../../../features/inventory/count-form-page";

export const Route = createFileRoute("/_app/inventory/counts/new")({ component: CountFormPage });
